import React, { useState } from "react";
import { Box } from "@mui/material";
import { CustomTooltip } from "./tooltip/Tooltip";
import Text from "./text/Text";

function TruncatedTextTooltip({
  textValue,
  cellWidth,
  textProps,
  boxProps,
  fontSize,
  ...props
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = (event) => {
    let element = event.target;
    setShowTooltip(element.offsetWidth < element.scrollWidth);
  };

  return (
    <CustomTooltip
      {...props}
      text={<>{textValue}</>}
      position="top"
      disableHoverListener={!showTooltip}
    >
      <Box
        style={{ maxWidth: cellWidth }}
        onMouseEnter={(event) => handleMouseEnter(event)}
        {...boxProps}
      >
        <Text
          size={fontSize || 16}
          font="regular"
          variant="subtitle1"
          noWrap
          {...textProps}
        >
          {textValue}
        </Text>
      </Box>
    </CustomTooltip>
  );
}

export default TruncatedTextTooltip;
